/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

(function () {
    pagination(true);
})();

// (function () {
//     if (!document.body.classList.contains('post-template')) return;

//     const cover = document.querySelector('.gh-cover');
//     if (!cover) return;

//     const image = cover.querySelector('.gh-cover-image');

//     window.addEventListener('load', function () {
//         cover.style.setProperty('--cover-height', image.clientWidth * image.naturalHeight / image.naturalWidth + 'px');
//         cover.classList.remove('loading');
//     });
// })();
/* Mobile menu burger toggle */
(function () {
    var burger = document.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!document.body.classList.contains('is-head-open')) {
            document.body.classList.add('is-head-open');
        } else {
            document.body.classList.remove('is-head-open');
        }
    });
})();